import { urlRootPath } from 'helpers/urlPath'
import { SPORTSMEN_URL_PART } from 'pages/Sportsmen/_constants/SPOTRSMEN_URLS'
import { EVENTS_URL_PART } from 'pages/Events/_constants/EVENTS_URLS'
import { COACHES_URL_PART } from 'pages/Coaches/_constants/COACHES_URLS'
import { ORGANIZATIONS_URL_PART } from 'pages/Organizations/_constants/ORGANIZATIONS_URLS'
// TODO: Рудимент. Удалить позже

export const FIND_URL_PART = 'find',
  FIND_URL = urlRootPath(FIND_URL_PART),
  FIND_SPORTSMANS_URL = urlRootPath(SPORTSMEN_URL_PART),
  FIND_EVENTS_URL = urlRootPath(EVENTS_URL_PART),
  FIND_COACHES_URL = urlRootPath(COACHES_URL_PART),
  FIND_ORGANIZATIONS_URL = urlRootPath(ORGANIZATIONS_URL_PART)
